import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgIconPlayIconOnly = (props, ref) => _jsx("svg", { viewBox: "0 0 24 26", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "currentColor", ref: ref, ...props, children: _jsx("path", { d: "M20.8 9.198c2.933 1.69 2.933 5.914 0 7.604L7.6 24.405c-2.933 1.69-6.6-.422-6.6-3.802V5.397C1 2.017 4.667-.095 7.6 1.595z" }) });
const ForwardRef = forwardRef(SvgIconPlayIconOnly);
export default ForwardRef;
